

module.exports = () => ~~(Math.random() * 256);



// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/internal/randomPartial.js